export function getQueryParams(locationSearch?: string) {
  const search = locationSearch ? locationSearch : window.location.search;
  const urlSearchParams = new URLSearchParams(search);
  return Object.fromEntries(urlSearchParams.entries());
}
